import getConfig from 'next/config';

import rollbar from '~/src/utilities/libs/rollbar';

const {publicRuntimeConfig: config} = getConfig();

interface LogPayload {
    error?: Error;
    [key: string]: any;
}
type Log = (message: string, data: LogPayload) => boolean;
type Severity = 'debug' | 'info' | 'warning' | 'error' | 'critical';

export const log = (severity: Severity, message: string, data: LogPayload) => {
    if (config.logger.severity.includes(severity)) {
        rollbar.log(severity, message, data);

        return true;
    }

    switch (severity) {
        case 'critical':
        case 'error':
            console.error(`[${severity}]${message}`, data);
            return true;
        case 'warning':
            console.warn(`[${severity}]${message}`, data);
            return true;
        case 'info':
            console.info(`[${severity}]${message}`, data);
            return true;
        case 'debug':
            if (process.env.NODE_ENV === 'development') {
                console.debug(`[${severity}]${message}`, data);
                return true;
            }
            return false;
        default:
            return false;
    }
};

export const debug: Log = (message, data) => log('debug', message, data);
export const info: Log = (message, data) => log('info', message, data);
export const warn: Log = (message, data) => log('warning', message, data);
export const error: Log = (message, data) => log('error', message, data);
export const critical: Log = (message, data) => log('critical', message, data);

export const Logger = {
    debug,
    info,
    warn,
    error,
    critical
};
